<template>
  <div id="date-picker">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      full-width
      max-width="290px"
      min-width="290px"
    >
      <v-text-field
        slot="activator"
        v-model="dateFormatted"
        :rules="required ? validDateRules : []"
        :label="label"
        :prepend-icon="icon"
        @blur="parseDate"
      />

      <v-date-picker
        v-model="internalDate"
        :type="type"
        :min="afterToday ? new Date().toISOString().slice(0,10) : null"
        @input="setDate"
      >
        <v-spacer />
        <v-btn
          flat
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          flat
          color="primary"
          @click="$refs.menu.save(internalDate)"
        >
          Save
        </v-btn>
      </v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'DateInput',

  props: {
    value: { type: String, required: true },
    label: { type: String, default: 'Date' },
    icon: { type: String, default: 'event' },
    type: { type: String, default: 'date' },
    required: { type: Boolean, default: false },
    format: { type: String, default: '' },
    afterToday: { type: Boolean, default: false },
    uppercase: { type: Boolean, default: false }
  },
  data () {
    return {
      menu: false,
      internalDate: null,
      dateFormatted: null,
      validDateRules: [
        v => !!v || 'This field is required.'
      ]
    }
  },

  watch: {
    value (newVal, oldVal) {
      this.internalDate = newVal
      this.dateFormatted = this.formatDate(this.internalDate)
    }
  },

  created () {
    this.internalDate = this.value
    this.dateFormatted = this.formatDate(this.internalDate)
  },

  methods: {
    setDate (date) {
      this.dateFormatted = this.formatDate(date)
      this.$emit('input', this.internalDate)
    },

    formatDate (date) {
      if (!date) {
        return ''
      }

      if (this.type === 'date') {
        if (this.format !== '') {
          if (this.uppercase) { return this.$moment(date).format(this.format).toUpperCase() } else { return this.$moment(date).format(this.format) }
        } else {
          const [year, month, day] = date.split('-')
          return `${month}/${day}/${year}`
        }
      } else if (this.type === 'month') {
        return this.$moment(date).format('MMMM YYYY')
      }
    },

    parseDate () {
      if (!this.dateFormatted) {
        this.internalDate = ''
      }

      if (this.type === 'date' && this.dateFormatted) {
        const [month, day, year] = this.dateFormatted.split('/')
        if (!!month && !!day) { this.internalDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}` }
      }

      this.$emit('input', this.internalDate)
    }
  }

}
</script>
